// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2pLSz","legacyBtn":"MutateMid_legacyBtn__1O31f"};